<div class="container-fluid about">
  <div class="row justify-content-center about-bg">
    <div class="col-12 col-lg-10">
      <div class="col-12 separator pdestacadas"></div>
      <div class="row">
        <div class="col-12 text-center mt-5 title1">
          <h1>{{ "NOSOTROS" | translate }}</h1>
        </div>
        <div class="col-12 col-lg-11 title">
          <h2>{{ "ABOUT1" | translate }}</h2>
        </div>
      </div>
    </div>

    <div class="col-12 col-lg-9">
      <div
        id="carouselExampleControls"
        class="carousel slide"
        data-bs-ride="carousel"
      >
        <div class="carousel-inner">
          <div class="carousel-item active">
            <img
              src="../../assets/img/about_c1.jpg"
              class="d-block w-100"
              alt="About Batista"
            />
          </div>

          <div class="carousel-item">
            <img
              src="../../assets/img/about_c2.jpg"
              class="d-block w-100"
              alt="About Batista"
            />
          </div>

          <div class="carousel-item">
            <img
              src="../../assets/img/about_c3.jpg"
              class="d-block w-100"
              alt="About Batista"
            />
          </div>
        </div>
        <button
          class="carousel-control-prev"
          type="button"
          data-bs-target="#carouselExampleControls"
          data-bs-slide="prev"
        >
          <span class="carousel-control-prev-icon" aria-hidden="true"></span>
          <span class="visually-hidden">Previous</span>
        </button>
        <button
          class="carousel-control-next"
          type="button"
          data-bs-target="#carouselExampleControls,#carouselExampleControls2"
          aria-controls="#carouselExampleControls,#carouselExampleControls2"
          data-bs-slide="next"
        >
          <span class="carousel-control-next-icon" aria-hidden="true"></span>
          <span class="visually-hidden">Next</span>
        </button>
      </div>
    </div>
  </div>

  <div class="row justify-content-center">
    <div class="col-12 title2 text-center mt-5">
      <h2>{{ "CONTACTANOS" | translate }}</h2>
    </div>
    <div class="col-12 col-md-4 founder text-center funo">
      <p>ALEX OTERO</p>
      <p><small>CO FOUNDER</small></p>
      <p>+56 9 9709 0208</p>
    </div>
    <div class="col-12 col-md-4 founder text-center funo2">
      <p>BÁRBARA GARCÍA</p>
      <p><small>CO FOUNDER</small></p>
      <p>+56 9 6453 0990</p>
    </div>
  </div>
</div>
